import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { actions as AuthActions } from "../../store/authRedux/actions";

/**
 * جایی که کاربر بعد از یک ورودِ موفق می‌نشیند.
 *
 * این تصمیم به مسیرِ ورود ربطی ندارد — چه با کد پیامکی آمده باشد، چه با حساب
 * گوگل، چه تازه نام و نام خانوادگی‌اش را ذخیره کرده باشد — و همیشه یکی از این
 * چهار حالت است: تنها سازمانش، فهرست سازمان‌ها، پرتالِ مشتری، یا ساختِ سازمان.
 * چون بیش از یک صفحه به آن می‌رسد، اینجا یک‌جا نوشته شده تا صفحه‌ی تازه، مسیرِ
 * «مشتری» یا «بدون سازمان» را از قلم نیندازد.
 */
const useLoginLanding = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const goToPanel = (org) => {
    dispatch(AuthActions.setOrganization(org));
    dispatch(AuthActions.setPortalCustomer(null));
    dispatch(AuthActions.setAuthenticated(true));
  };

  /* کسی که هیچ سازمانی ندارد ولی جایی مشتری است، به‌جای «ساخت سازمان» به پرتال
     همان مشتری می‌رود. حالت نادرِ «هم عضو، هم مشتری» از سوییچر فضای کاری عبور
     می‌کند، نه از صفحه‌ی ورود. */
  const goToPortal = (membership) => {
    dispatch(AuthActions.setOrganization(membership.organization));
    dispatch(AuthActions.setPortalCustomer(membership));
    dispatch(AuthActions.setAuthenticated(true));
  };

  const land = ({ organizations, memberships } = {}) => {
    const orgs = organizations || [];
    const customerOf = memberships || [];

    if (orgs.length > 0) {
      if (orgs.length === 1) {
        goToPanel(orgs[0]);
      } else {
        navigate("/select-org", { replace: true });
      }
    } else if (customerOf.length > 0) {
      goToPortal(customerOf[0]);
    } else {
      navigate("/register", { replace: true });
    }
  };

  return { goToPanel, goToPortal, land };
};

export default useLoginLanding;
